module.exports = __webpack_public_path__ + "img/unifisa-parceiros-logo-menu.811c19dd.png";